import Icon from 'src/ui/atoms/icon';
import styled from 'styled-components';

export const NameContainer = styled.div`
  display: flex;
`;

export const DeleteIcon = styled(Icon)`
  margin-left: 0.5rem;
`;

export const SelectContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
